import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO14 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK001-4.jpg"
      title="Reserved avatar"
      alt="Reserved avatar"
    />
  )
}

export default ImageMO14
